import React, { useEffect ,useState} from 'react';
import './styles.css';
import { useHistory } from 'react-router-dom'
import { subscriptionURL, bookcover,serverurl, logo, appName } from '../../api/api';
import { Col, Image, Row } from "antd";
import Space from '../../component/dashboard/space';
import { ReadOutlined, FilePdfOutlined } from '@ant-design/icons';
import Emptycard from '../../component/Empty';
import Skeletonbook from '../../component/skeleton/skeletonbook';
import Error500 from '../error/500';
import axios from 'axios';
import { REST_API_URL, REST_USER_API_URL, YM_LOGIN_URL } from '../../api/content-novareader';


const fetchUserCredentials = () => {
    try {
      return JSON.parse(localStorage.getItem("lpp_userCredentials")) || null;
    } catch (error) {
      console.error("Error parsing user credentials:", error);
      return null;
    }
};

const Subscription = () => {
    const [userCredentials, setUserCredentials] = useState(null);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);
    const [data, setData] = useState([]);
    const isOnline = navigator.onLine; // Check online status

    useEffect(() => {
      window.scrollTo(0, 0);
      const credentials = fetchUserCredentials();
      setUserCredentials(credentials);
    }, []);

    // Handle state change based on online status and user credentials
    useEffect(() => {
        if (userCredentials === null) {
            return; // Prevent running logic when credentials are still null
        }
        
        if (isOnline) {
            handleOnlineState();
        } else {
            handleOfflineState();
        }
    }, [isOnline, userCredentials]); 

    const handleOnlineState = () => {
  
      if (!userCredentials || userCredentials.emailVerified !== 1) {
        history.push('/login');
        return;
      }
      fetchSubscriptionData();
    };
  
    const handleOfflineState = () => {
      setIsLoading(true);
      openDatabase("subscriptions")
        .then((db) => {
          const transaction = db.transaction("subscriptions", "readonly");
          const store = transaction.objectStore("subscriptions");
          const getRequest = store.get("subscriptions"); // "dashboard" is the fixed key
    
          getRequest.onsuccess = function (event) {
            const record = event.target.result;
            setData(record ? record.data : null);
            setIsLoading(false);
            db.close();
          };
    
          getRequest.onerror = function (event) {
            console.error("Error loading dashboard data:", event.target.error);
            db.close();
          };
        })
        .catch((error) => {
          console.error("Error opening database:", error);
        });
    };

    const fetchSubscriptionData = async() => {
      setIsLoading(true);    
      let response;
      try {
    
        if (!userCredentials || !userCredentials.apiKey) {
          throw new Error("Invalid user credentials");
        }
        const response = await axios.get(REST_API_URL+'/user/subscription/books', {
          headers: { apikey: userCredentials.apiKey },
        });
        
        var data = response.data.data;    
        setData(response.data.data || []);
        setIsLoading(false);
        for (let book of data) {
          const res = await fetch(bookcover + book.fuzzyId + "/" + book.cover); // Fetch the image
          const blob = await res.blob(); // Convert response to Blob
          const reader = new FileReader();
    
          // Convert the Blob to Base64 and store it in coverUrl
          await new Promise((resolve, reject) => {
            reader.onloadend = () => {
              book['coverUrl'] = reader.result; // Set coverUrl
              resolve(); // Resolve when done
            };
            reader.onerror = reject; // Reject on error
            reader.readAsDataURL(blob); // Convert Blob to Base64
          });
        }
        saveDataToIndexedDB("subscriptions", data);  
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.removeItem('lpp_userCredentials');
            window.location.href = YM_LOGIN_URL;
            return;
          }
        }
        console.error("Error fetching subscription data:", error);
        setData([]);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    const openDatabase = (storeName) => {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("MyDataBase");
    
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains(storeName)) {
            console.error(`Object store '${storeName}' not found.`);
            db.createObjectStore(storeName, { keyPath: "id" });
          }
        };
    
        request.onsuccess = (event) => {
          const db = event.target.result;
    
          // If the store exists, return the database
          if (db.objectStoreNames.contains(storeName)) {
            console.log(`Object store "${storeName}" already exists.`);
            return resolve(db);
          }
    
          console.warn(`Object store "${storeName}" is missing. Upgrading database...`);
          db.close();
    
          // Increment the version to trigger onupgradeneeded
          const newVersion = db.version + 1;
          console.log('newVersion', newVersion);
          const upgradeRequest = indexedDB.open("MyDataBase", newVersion);
    
          upgradeRequest.onupgradeneeded = (event) => {
            const upgradeDb = event.target.result;
    
            // Create only the missing object store
            if (!upgradeDb.objectStoreNames.contains(storeName)) {
              console.log(`Creating missing object store: ${storeName}`);
              upgradeDb.createObjectStore(storeName, { keyPath: "id" });
            }
          };
    
          upgradeRequest.onsuccess = (event) => {
            console.log(`Database upgraded. Object store "${storeName}" added.`);
            resolve(event.target.result);
          };
    
          upgradeRequest.onerror = (event) => {
            reject(event.target.error);
          };
        };
    
        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    };         
  
    const saveDataToIndexedDB = async (storeName, data) => {
      try {
        const db = await openDatabase(storeName);
        const transaction = db.transaction(storeName, "readwrite");
        console.log('storeName', storeName);
        const store = transaction.objectStore(storeName);
  
        // Use a fixed key to ensure that the record is overwritten each time.
        const dashboardRecord = {
          id: storeName, // fixed key
          data: data,      // your dashboard data
          timestamp: new Date().toISOString(), // Optional: keep a timestamp for reference
        };
  
        const requestPut = store.put(dashboardRecord);  
        requestPut.onsuccess = () => {
          console.log("Dashboard data successfully saved (overwritten) in IndexedDB");
        };
  
        requestPut.onerror = (event) => {
          console.error("Error saving dashboard data to IndexedDB:", event.target.error);
        };
  
        transaction.oncomplete = () => {
          db.close();
        };
  
      } catch (error) {
        console.error("Error opening database or saving dashboard data:", error);
      }
    };  

    const goTopdf = (item) => {
        history.push({pathname:'/read/book/pdf/'+item.elasticId,state:{contentid:item.contentId,fuzzyid:item.fuzzyId,isbn:item.identifier,name:item.title,type:"book",isonline:'yes',cover:item.cover,info:item,auth:item.authors.map(item => item.surName+" "+item.givenName)}})
    }

    const goToepub = (item) => {
        history.push({pathname:'/read/book/epub/'+item.elasticId,state:{contentid:item.contentId,isbn:item.identifier,name:item.title,type:"book",fuzzyid:item.fuzzyId,cover:item.cover,info:item,auth:item.authors.map(item => item.surName+" "+item.givenName)}})
    }
    
    const goToDeacriton = (item) => {
        history.push({pathname:'/book/isbn/'+ item.identifier,state:{contentid:item.contentId,fuzzyid:item.fuzzyId}})
    }

    if(isLoading){
        return( <Skeletonbook/>)
    }
    if(error){
        return(<Error500/>)
    }

    if (data.length === 0) {
        return(
            <div style={{display: 'flex', height: '80vh', width: '100%', alignItems: "center", justifyContent: 'center' }}>
                <Emptycard btntext="Subscribe Now" descriptin="You don't have any Subscription" link={()=>{ window.open( serverurl,'_blank');}}/>
              </div>
        )
    }
   
    const readButton = (item) => {
        let locaion = JSON.parse(localStorage.getItem(item.title));
        let buttontext = "Start Reading";
        if (locaion) {
            buttontext = "Continue Reading"
        }
        if (item.format === "epub,webpdf") {
            return (
                <div>
                    <div className='sub-read'>
                       <div className='sub-read-name'>EBOOK (EPUB)</div>
                       <div className="icons">
                        <ReadOutlined onClick={()=>goToepub(item)} className="readr-icon" style={{padding:'6px'}}/>    </div>
                    </div>
                    <div className='sub-read'>
                    <div className='sub-read-name'> EBOOK (PDF)</div>
                       <div className="icons">
                        <FilePdfOutlined onClick={()=>goTopdf(item)} className="readr-icon" style={{padding:'6px'}}/>    </div>
                    </div>
                </div>
            )
        } else if (item.format === "epub") {
            return (
                <div>
 <div className='sub-read'>
                       <div className='sub-read-name'>EBOOK (EPUB)</div>
                       <div className="icons">
                        <ReadOutlined onClick={()=>goToepub(item)} className="readr-icon" style={{padding:'6px'}}/>    </div>
                    </div>                </div>
            )
        } else if(item.format === "webpdf") {
            return (
                <div>
 <div className='sub-read'>
                    <div className='sub-read-name'> EBOOK (PDF)</div>
                       <div className="icons">
                        <FilePdfOutlined onClick={()=>goTopdf(item)} className="readr-icon" style={{padding:'6px'}}/>    </div>
                    </div>                </div>
            )
        }
    }

    const getCoverImage = (book) => {
      if (isOnline) {
        return bookcover + book.fuzzyId + "/" + book.cover;
      } else {
        return book.coverUrl; 
      }
    };
  
    return (
      <Row className="cards-container">
        {data.map((item) => {
          return (
            <Col
              key={item.fuzzyId}
              xs={12}
              md={6}
              style={{ float: 'left', marginTop: '10px', padding: '10px' }}
            >
              <div className="bookcover_continer" >
                <Image className="bookcover"
                  onClick={() => goToDeacriton(item)}
                  preview={false}
                  fallback="data:image/png;base64,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"
                  src={getCoverImage(item)} 
                  alt={item.fullName} />
              </div>
              <div className="bookcontent">
                <div onClick={() => { goToDeacriton(item) }}>
                  <div className="booktitle" >{item.fullName}</div>
                </div>
                <div className="readbtncontiner">
                    {readButton(item)}
                </div>
              </div>
            </Col>                     
          )
        })}
        <Space hig="10px" color="#ffffff" />
        </Row>
    );
}

export default Subscription;